import { ConfigMenuItem, useConfigStore } from '../../Stores/Config';
import { useNewsStore } from '../../Stores/News';
import { useSessionStore } from '../../Stores/Session';
import { useTicketStore } from '../../Stores/Ticket';
import ConversationItem from '../ConversationItem/ConversationItem';
import NewsCard from '../NewsCard/NewsCard';
import WidgetMenuButton from '../WidgetMenuButton/WidgetMenuButton';
import "./WidgetMenu.scss";

function WidgetMenu() {
    const configStore = useConfigStore();
    const ticketStore = useTicketStore();
    const newsStore = useNewsStore();
    const sessionStore = useSessionStore();

    const canRenderMenuItem = (menuItem: any) => {
        const isUser = sessionStore.session?.userId && sessionStore.session?.userId?.length > 0;

        if (menuItem?.targetAudience === "users" && !isUser) {
            return false;
        }

        if (menuItem?.targetAudience === "guests" && isUser) {
            return false;
        }

        return true;
    }

    const unreadTickets = ticketStore.previousTickets.filter((ticket) => {
        if (ticket.sessionNotificationsUnread) {
            return true;
        }
        return false;
    });

    const renderNews = () => {
        if (configStore.config.hideNews || !newsStore.latestArticle || configStore.config.showNoHomeNews) {
            return null;
        }

        return (
            <div className='widget-app-container'>
                <div className='widget-app-container-body'>
                    <NewsCard news={newsStore.latestArticle} />
                </div>
            </div>
        );
    }

    return (<>
        {unreadTickets && unreadTickets.length > 0 &&
            <div className='widget-unread-messages-container'>
                {
                    unreadTickets.slice(0, 2).map((ticket, index) => {
                        return <ConversationItem ticket={ticket} index={index} key={ticket.bugId} />
                    })
                }
            </div>}
        {configStore.config?.menuItems?.map((menuItem: ConfigMenuItem, key: any) => {
            if (!canRenderMenuItem(menuItem)) {
                return null;
            }

            return (
                <div className='widget-menu-button-container' key={key}>
                    <div className='widget-menu-buttons'>
                        <WidgetMenuButton menuItem={menuItem} index={key} />
                    </div>
                </div>);
        })}
        {renderNews()}
    </>);
}

export default WidgetMenu;
